<p-table #dt styleClass="p-datatable-responsive-demo" [value]="dealerList" dataKey="sk" [paginator]="true"
    [rows]="10" [showCurrentPageReport]="true" [loading]="!dealerList"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,25,50]"
    [globalFilterFields]="['name',]"
    sortMode="multiple">
    <ng-template pTemplate="caption">
        <div class="table-header d-flex">
            <div class="flex-grow-1">
                <span class="p-float-label p-input-icon-left m-2 w-100">
                    <i class="pi pi-search "></i>
                    <input pInputText class="w-100" id="globalSearch" name="globalSearch" style="width: 100%"
                        type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" />
                    <label for="globalSearch">Dealer search...</label>
                </span>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" #header>
        <tr>
            <th pSortableColumn="name">
                Name
                <p-sortIcon field="name"></p-sortIcon>
            </th>
            <th pSortableColumn="venues.length">
                Venues
                <p-sortIcon field="venues.length"></p-sortIcon>
            </th>
            <th>
                Contact
                
            </th>
            <th>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" #body let-rec let-idx=index>
        <tr>
            <td>
                <span class="p-column-title">Name</span>
                {{rec.name}}
            </td>
            <td>
                <span class="p-column-title">Venues</span>
                {{rec.venues?.length}}
            </td>
            <td>
                <span class="p-column-title">Contact</span>
                <div class="d-flex">
                    <div *ngIf="rec.supportPhone || rec.supportEmail">Support</div>
                    <div *ngIf="rec.supportPhone">{{app.references.phoneNumberToDisplayFormat(rec.supportPhone)}}</div>
                    <div>{{rec.supportEmail}}</div>
                </div>
                <div class="d-flex">
                    <div *ngIf="rec.adminPhone || rec.adminEmail">Admin</div>
                    <div *ngIf="rec.adminPhone">{{app.references.phoneNumberToDisplayFormat(rec.adminPhone)}}</div>
                    <div>{{rec.adminEmail}}</div>
                </div>
            </td>
            <td>
                <p-button pRipple styleClass="p-button-raised p-button-info m-2" (click)="dealerIdSelectedEmitter.emit(rec.key)">
                    <ng-template pTemplate="content">
                        <div class="d-flex justify-content-center">
                            <fa-icon [icon]='["far","info-circle"]' size="lg" class="ms-1 me-2"></fa-icon>
                            Dealer Info
                        </div>
                    </ng-template>
                </p-button>
            </td>
        </tr>
    </ng-template>
</p-table>